export default __webpack_public_path__ + "static/media/reaction-07.36d2f8a0.svg";